import React, { useState } from "react";
import Header from "../Header";
import logo from "../../images/Assets/logo.png";
import logo1 from "../../images/Assets/logo1.png";
import card from "../../images/Assets/card.png";
import AboutUs from "./AboutUs";
import Features from "./Features";
import Interface from "./Interface";
import Deploy from "./Deploy";
import Service from "./Service";
import Consult from "./Consult";
import Testimonials from "./Testimonials";
import Customer from "./Customer";
import Footer from "./Footer";

const LandingPage = () => {
  const [selectedTab, setSelectedTab] = useState("compare");

  const handleTabChange = (tab) => {
    setSelectedTab(tab);
  };
  return (
    <div>
      <div className="bgImage w-full h-screen">
        <Header />

        <div className="flex flex-col items-center justify-center h-[calc(100vh-94px)] px-6">
          <img src={logo} alt="logo" />

          <div className="xl:text-[46px] text-[72px] text-[#0E062A] text-center font-gilroySemibold xl:leading-tight leading-[80px] mt-6">
            Developing Gen AI <br className="block md:hidden" /> based products
          </div>

          <div className="lg:text-[16px] text-[18px] text-[#544D68] text-center font-gilroyRegular mt-5">
            Lorem ipsum dolor sit amet consectetur. Nulla interdum <br className="block md:hidden" /> non eu
            est. Iaculis libero eget sed diam cras.
          </div>

          <div className="bg-[#7846F0] w-fit text-[16px] text-[#FFFFFF] font-gilroySemibold py-2.5 px-11 rounded-full cursor-pointer mt-7">
            Book a free call
          </div>
        </div>
      </div>

      <div id="about">
        <AboutUs />
      </div>

      <div id="features">
        <Features />
      </div>

      <Interface />

      <div id="ourproduct">
        <Deploy />
      </div>

      <div className="md:px-6 xl:px-10 px-28 py-20">
        <div className="backgroundImage max-w-7xl mx-auto rounded-[30px] lg:px-6 xl:px-8 px-16 lg:py-6 xl:py-8 py-14">
          <div className="bg-[#FFFFFF] flex items-center justify-between overflow-auto p-2 rounded-xl w-full">
            <div
              className={`${selectedTab === "compare" ? "bg-[#7846F0] text-[#FFFFFF]" : "bg-transparent text-[#0E062A]"
                } xl:text-[16px] text-[22px] font-gilroySemibold py-1 xl:px-7 px-11 rounded-xl cursor-pointer text-nowrap`}
              onClick={() => handleTabChange("compare")}
            >
              Compare GPT
            </div>

            <div
              className={`${selectedTab === "research" ? "bg-[#7846F0] text-[#FFFFFF]" : "bg-transparent text-[#0E062A]"
                } xl:text-[16px] text-[22px] font-gilroySemibold py-1 xl:px-7 px-11 rounded-xl cursor-pointer text-nowrap`}
              onClick={() => handleTabChange("research")}
            >
              Researcher GPT
            </div>

            <div
              className={`${selectedTab === "modal" ? "bg-[#7846F0] text-[#FFFFFF]" : "bg-transparent text-[#0E062A]"
                } xl:text-[16px] text-[22px] font-gilroySemibold py-1 xl:px-7 px-11 rounded-xl cursor-pointer text-nowrap`}
              onClick={() => handleTabChange("modal")}
            >
              Komodo for Model Risk
            </div>

            <div
              className={`${selectedTab === "advisor" ? "bg-[#7846F0] text-[#FFFFFF]" : "bg-transparent text-[#0E062A]"
                } xl:text-[16px] text-[22px] font-gilroySemibold py-1 xl:px-7 px-11 rounded-xl cursor-pointer text-nowrap`}
              onClick={() => handleTabChange("advisor")}
            >
              Rob Advisor
            </div>
          </div>

          <div className="flex md:flex-col flex-row items-start justify-center xl:gap-14 gap-28 mt-9">
            <div className="w-full">
              <img src={logo1} alt="logo1" className="w-[192px] h-[38px]" />

              <div className="lg:text-[28px] text-[40px] text-[#0E062A] font-gilroySemibold lg:leading-tight leading-[52px] text-start mt-3">
                Effortless and accurate <br className="2xl:hidden block" /> document comparison
              </div>

              <div className="lg:text-[16px] text-[18px] text-[#544D68] font-gilroyRegular text-start mt-5">
                Lorem ipsum dolor sit amet consectetur. Enim gravida <br className="2xl:hidden block" />{" "}
                aliquam sed elementum interdum. Etiam mauris lorem <br className="2xl:hidden block" /> rutrum
                in aenean porttitor dui fermentum. Pellentesque <br className="2xl:hidden block" /> sagittis
                diam velit integer. Et interdum id tortor viverra mi.
              </div>
            </div>

            <div className="flex items-center justify-center w-full">
              <img src={card} alt="card" className="w-[545px]" />
            </div>
          </div>
        </div>
      </div>

      <div id="service">
        <Service />
      </div>

      <Consult />

      <div className="md:px-6 xl:px-10 px-28 py-20">
        <div className="backgroundImage1 max-w-7xl mx-auto rounded-[30px] md:px-6 px-16 md:py-6 py-16">
          <div className="w-fit mt-2">
            <div className="bg-[#F4F2FE] text-[14px] text-[#5B2ED9] font-gilroySemibold uppercase w-fit py-0.5 px-2.5 rounded-full">
              Keep it simple
            </div>

            <div className="md:text-[28px] text-[40px] text-[#0E062A] font-gilroySemibold md:leading-[52px] text-start mt-2">
              Advanced AI, Simplified
            </div>

            <div className="md:text-[16px] text-[18px] text-[#544D68] font-gilroyRegular text-start mt-4">
              AI can seem complicated, but it doesn't have to be. We break down{" "}
              <br className="md:hidden block" /> complex AI concepts into manageable parts, making them easily{" "}
              <br className="md:hidden block" /> understandable and seamlessly integrated into your business.
              Our goal <br className="md:hidden block" /> is to make AI accessible, comprehensible, and
              beneficial for all.
            </div>
          </div>
        </div>
      </div>

      <div id="testimonials">
        <Testimonials />
      </div>

      <Customer />

      <Footer />
    </div>
  );
};

export default LandingPage;
